import { css } from '@design.estate/dees-element';
import { echartsBaseStyles } from '../dees-chart-echarts-styles.js';

export const radarStyles = [
  ...echartsBaseStyles,
  css``,
];
